export default "/images/x-octagon.svg?55ccf9162209f6b2b4559913f366bc4b";